var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col"},[_c('H4',{staticClass:"font-semibold mb-6"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',[_c('body',{class:[
        'text-sm rounded-sm px-8 font-semibold py-2 inline',
        _vm.gender === 'm' ? 'bg-blue-200' : 'bg-purple-200',
      ]},[_vm._v(" "+_vm._s(_vm.gender === 'm' ? 'MALE' : 'FEMALE')+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }